const API_BASE = process.env.REACT_APP_API_URL || '';

function getHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  
  // Telegram WebApp auth
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    // Dev mode
    headers['X-Dev-User'] = '100001';
  }
  
  return headers;
}

async function request(url, opts = {}) {
  const res = await fetch(API_BASE + url, {
    headers: getHeaders(),
    ...opts,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Network error' }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
}

// Stats
export const getStats = () => request('/api/stats');

// Objects
export const getObjects = (params = '') => request('/api/objects' + (params ? '?' + params : ''));
export const getObject = (id) => request('/api/objects/' + id);
export const createObject = (data) => request('/api/objects', { method: 'POST', body: JSON.stringify(data) });
export const updateObject = (id, data) => request('/api/objects/' + id, { method: 'PATCH', body: JSON.stringify(data) });
export const deleteObject = (id) => request('/api/objects/' + id, { method: 'DELETE' });

// Questions
export const getQuestions = (params = '') => request('/api/questions' + (params ? '?' + params : ''));
export const getQuestion = (id) => request('/api/questions/' + id);
export const createQuestion = async (formData) => {
  const headers = {};
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    headers['X-Dev-User'] = '100001';
  }
  const res = await fetch(API_BASE + '/api/questions', { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Ошибка сети' }));
    throw new Error(err.error || 'Не удалось отправить вопрос');
  }
  return res.json();
};
export const answerQuestion = async (id, formData) => {
  const headers = {};
  if (window.Telegram?.WebApp?.initData) {
    headers['X-Telegram-InitData'] = window.Telegram.WebApp.initData;
  } else {
    headers['X-Dev-User'] = '100001';
  }
  const res = await fetch(API_BASE + '/api/questions/' + id + '/answer', { method: 'POST', headers, body: formData });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Ошибка сети' }));
    throw new Error(err.error || 'Не удалось отправить ответ');
  }
  return res.json();
};

// Events
export const getEvents = (params = '') => request('/api/events' + (params ? '?' + params : ''));
export const getEvent = (id) => request('/api/events/' + id);
export const registerEvent = (id) => request('/api/events/' + id + '/register', { method: 'POST' });
export const unregisterEvent = (id) => request('/api/events/' + id + '/register', { method: 'DELETE' });

// Library
export const getLibrary = () => request('/api/library');
export const getLibraryCategory = (cat, params = '') => request('/api/library/' + cat + (params ? '?' + params : ''));
export const getLibraryItem = (id) => request('/api/library/item/' + id);

export const getLibraryFolders = (catSlug) => request('/api/library/folders/' + catSlug);
export const searchLibrary = (q) => request('/api/library/search?q=' + encodeURIComponent(q));

// Subscription
export const getSubscription = () => request('/api/subscription');
export const markNotificationsRead = () => request('/api/subscription/notifications/read', { method: 'POST' });

// Onboarding
export const submitOnboarding = (data) => request('/api/onboarding', { method: 'POST', body: JSON.stringify(data) });
export const postWelcome = () => request('/api/onboarding/welcome', { method: 'POST' });
export const getWelcomeStatus = () => request('/api/onboarding/welcome-status');
export const getGuideStatus = () => request('/api/onboarding/guide');
export const postGuideStep = (step) => request('/api/onboarding/guide', { method: 'POST', body: JSON.stringify({ step }) });

// AI Assistant
export const sendAssistantMessage = (message, history) => request('/api/assistant', { method: 'POST', body: JSON.stringify({ message, history }) });

